<template>
    <div :class="['item-card', { 'cursor-pointer': clickable }]">
        <div class="item-name">{{ formatItemTypeTitle() }}</div>
        <v-icon
          class="item-icon"
          :icon="iconName"
        ></v-icon>
        <v-icon
          class="item-icon"
          :class="{ 'cursor-move': draggable }"
          icon="mdi-drag-vertical"
          size="small"
        ></v-icon>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FormItemCard',
  props: {
    name: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      required: true
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    formatItemTypeTitle (): string {
      const translationKeyByItemName: Record<string, string> = {
        TEXT_LABEL: 'i18n.textLabelTitle',
        MULTI_CHOICE: 'i18n.choiceInputTitle',
        TEXT_INPUT: 'i18n.textInputTitle',
        RATING: 'i18n.ratingInputTitle',
        NAVIGATION: 'i18n.navigationItemTitle',
        GRID: 'i18n.gridInputTitle'
      }

      const translationKey = translationKeyByItemName[this.name.toUpperCase()]
      if (translationKey) {
        return this.$t(translationKey) as string
      }

      const words = this.name.toLowerCase().split('_')
      return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/colors.scss";

.item-card {
    display: grid;
    grid-template-columns: 1fr min-content auto;
    align-items: center;
    padding: 0.4em 0em 0.4em 0.4em;
    margin-bottom: 0.4em;
    border: solid 2px $black;
    border-radius: 5px;

    .item-icon {
        justify-self: end;
    }
}
</style>
